module.exports = __webpack_public_path__ + "static/img/nfu_logo.99239bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nfu_logo.png
// module id = t7WK
// module chunks = 1